export default __webpack_public_path__ + "static/media/Punto_12_Finocchietti_DEU_Def.3dca8722.aac";